// ESM-Huelle fuer lib/scripts/components/CMP_CIframe.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CIframe (id)
{
    this.construct (id);

    this.name = "CIframe";
    this.htmlType = "iframe";
    
    this.properties =
    {
        attributes: {},
        styles:
        {
            position: "absolute"
        }
    }
}

CIframe.prototype = new CComponent;
export { CIframe };
